import {OrderListFilter} from "../models/order-list-filter.model";

export class GetOrderListAction {
  static readonly type = '[Order] GetOrderListAction';
  constructor() {}
}
export class GetOrderAction {
  static readonly type = '[Order] GetOrderAction';
  constructor(public payload: {orderId}) {}
}
export class CreateOrderAction {
  static readonly type = '[Order] CreateOrderAction';
  constructor(public payload: {userReceiverId:any, importe:any, password:string}) {}
}

export class SearchOrderListAction {
  static readonly type = "[Order] SearchOrderListAction";
  constructor(public payload: { filter: OrderListFilter }) {}
}
export class ResetOrderListFilter {
  static readonly type = "[Order] ResetOrderListFilter";
  constructor() {}
}
